// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S2vym","largestCol":"styles_largestCol__2gFcL","smallestCol":"styles_smallestCol__3e1dl"};